import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { CircleButtonProps } from './circle-button.props';

@Component({
  selector: 'lp2-circle-button',
  template: `
    <button class="circle-button" [style.color]="colors.color"
    (mouseover)="hover=true" (mouseleave)="hover=false"
    [ngStyle]="{
      color: hover ? colors.hover.color : colors.color,
      backgroundColor: hover  ? colors.hover.backgroundColor : colors.backgroundColor
    }">
      <i [ngClass]="class"></i>
    </button>
  `,
  styleUrls: ['./circle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleButtonComponent {
  @Input() set icon(_icon: string) {
    this.class = `fa ${_icon}`;
  }
  @Input() colors: CircleButtonProps;

  public class: string;
  public hover: boolean;
}

@NgModule({
  imports: [CommonModule],
  declarations: [CircleButtonComponent],
  exports: [CircleButtonComponent],
})
export class CircleButtonModule { }



// WEBPACK FOOTER //
// ./ts/app/components/circle-button/circle-button.component.ts